import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { CoreService } from "src/app/shared/services/core.service";
import { UtilitiesService } from "src/app/shared/services/utilities.service";
import {ThemeService} from "../services/theme.service";

@Injectable({
  providedIn: "root"
})
export class ProductResolver implements Resolve<boolean> {
  constructor(
    private facade: FacadeService,
    private coreService: CoreService,
    private themeService: ThemeService,
    private utils: UtilitiesService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>(async (res, rej) => {
      const productUid = route.queryParamMap.get("product");
      const utm = route.queryParamMap.get("utm");
      if (!productUid) { rej(false); }

      const product = await this.facade.getProduct(productUid!);
      if (!product) { rej(false); }

      this.themeService.setThemeByBrandId(product.brandId);
      this.facade.setBrandId(product.brandId.toString());
      this.facade.addStorageItem("productUid", productUid!);
      this.facade.addStorageItem("olbGroupId", product.olbGroupId.toString());
      this.facade.addStorageItem("allowJointApplications", product.allowJointApplications.toString());
      this.facade.allowJointApplications$.next(product.allowJointApplications.toString() === "true");

      res(true);

      /*
      let applicationRequest = this.facade.getShoppingCartApplicationLogsRequest();
      let step = this.utils.createStep(Step.NameEnum.ProductSelection, Step.StateEnum.Success, []);
      let applicationLogStepRequest = this.utils.createApplicationLogStepRequest(OnboardingStepEnum.PRODUCTIONSELECTION, OnboardingStateEnum.Success, OnboardingSourceEnum.Bb8, []);
      applicationLogStepRequest.applicationLogDetailsRequestList = new Array();

      applicationRequest.status = ApplicationLogsRequest.StatusEnum.Started;

      if (utm) {
        applicationRequest.utmCampaign = utm;
        step.logs!.push(this.utils.createLog("BB8", `UTM parameter detected. Value = ${utm}`));
        applicationLogStepRequest.applicationLogDetailsRequestList.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, `UTM parameter detected. Value = ${utm}`));
      }

      applicationRequest.url = location.href;

      step.logs!.push(this.utils.createLog("BB8", `Product: ${product.code} - ${product.name}, Brand: ${product.brandName}`));
      applicationLogStepRequest.applicationLogDetailsRequestList.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, `Product: ${product.code} - ${product.name}, Brand: ${product.brandName}`));

      // Multi product, initial setup takes place with the product sent from CMS
      const { name, accountType, productType, interestRate } = product;
      const productRequest: ApplicationProductRequest = {
        productCode: product.code?.toString(),
        productUID: productUid!,
        productDescription: name,
        accountType: accountType,
        productType: productType,
        interestRate: interestRate,
        interestPlanCode: this.facade.getInterestPlanCodes(product)
      }
      applicationRequest.products = [productRequest];
      applicationRequest.step = step;
      applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

      this.facade.setShoppingCartApplicationLogsRequest(applicationRequest);
      await this.facade.updateApplication();

      res(true);
      */
    });
  }
}
